import * as React from 'react';

import { connect } from 'react-redux';

import { FilterBase, IExternalProps } from './filter-base';
import { Dispatch } from 'redux';
import { removeFilter, upsertFilter } from '../redux-state/actions/filters';
import { goToPage } from '../redux-state/actions/listing';
import { IAppState } from '../classes/app';

interface DispatchToProps {
    updateFilter: (query: string) => void;
    updateSecondaryFilter: (property: string, query: string) => void;
}
export class ResultPerPage extends FilterBase {
    convertEvtToString(evt: React.ChangeEvent<HTMLSelectElement>) {
        return evt.target.value;
    }

    submitChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        // this.updateValue(evt);
        this.boundFilterUpdate(this.convertEvtToString(evt), true);
    }

    render() {
        return (
            <div className="adage-form-inline adage-search-results-header-qty">
                <label htmlFor={this.props.property} className="adage-search-results-header-label">Results per Page:</label>
                <select id={this.props.property} className="adage-search-results-header-input" value={this.props.selectedOptions ? this.props.selectedOptions : ""} onChange={this.submitChange.bind(this)} >
                    {
                        this.props.defaultOption ? <option value={this.props.defaultOption.value}>{this.props.defaultOption.text}</option> : null
                    }
                    {
                        this.props.options.map(option => <option key={`${option.value}~${option.text}`} value={option.value}>{option.text}</option>)
                    }
                </select>
            </div>
        )
    }
}

function mapStateToProps(state: IAppState, ownProps: IExternalProps) {
    const options = state.filtersState.filterOptions[ownProps.property];

    return {
        options: options ? options.map(option => { return { text: option, value: option } }) : [],
        selectedOptions: state.listingState.resultsPerPage ? state.listingState.resultsPerPage : "10"
    }
}

export function mapDispatchToProps(dispatch: Dispatch, ownProps: IExternalProps): DispatchToProps {
    return {
        updateFilter: (query: string) => {
            if (!query || query === "") {
                dispatch(removeFilter(ownProps.property));
            } else {
              
                dispatch(goToPage(1));
                dispatch(upsertFilter(ownProps.property, query) as any)
            }
        },
        updateSecondaryFilter: (property: string, query: string) => {
            if (!query || query === "") {
                dispatch(removeFilter(property));
            } else {
                dispatch(upsertFilter(property, encodeURIComponent(query)) as any)
            }
        }
    }
}

export const ConnectedResultePerPageDropdown = connect(mapStateToProps, mapDispatchToProps)(ResultPerPage);